import { FunctionComponent, useEffect } from 'react';
import { ContainerProps } from './types';
import View from './view';

/**
 * A wrapper component that covers the entire content of
 * the page and provides layout relevant CSS code.
 */
const Container: FunctionComponent<ContainerProps> = (props) => {
  // Reset scroll position and focus
  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById('root')?.focus();
  }, []);

  return <View {...props} />;
};

export default Container;
